/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  OutlinedTextFieldProps,
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput,
} from '@mui/material';
import { colors } from '@farmlands/mui-theme';

export interface TextFieldProps extends OutlinedTextFieldProps {
  testId?: string;
  helperTextColor?: string;
}

const TextField = ({
  label,
  error,
  helperText,
  placeholder,
  inputProps,
  InputProps,
  InputLabelProps,
  value,
  onChange,
  testId,
  multiline,
  minRows,
  maxRows,
  autoFocus,
  helperTextColor,
  sx,
  disabled,
}: TextFieldProps) => {
  return (
    <FormControl fullWidth>
      {label && <FormLabel {...InputLabelProps}>{label}</FormLabel>}
      <OutlinedInput
        sx={sx}
        ref={InputProps?.ref}
        {...InputProps}
        inputProps={{
          maxLength: 200,
          ...inputProps,
        }}
        placeholder={placeholder}
        error={error}
        value={value}
        onChange={onChange}
        data-testid={testId}
        multiline={multiline}
        minRows={minRows}
        maxRows={maxRows}
        autoFocus={autoFocus}
        disabled={disabled}
      />
      <FormHelperText error={error} sx={{ color: helperTextColor ?? colors.grey800 }}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};

export default TextField;
